import { findEditorTypeList, saveDiviceType, removeType } from '@/api/device'
const state = {
  showType: 'close',
  showExtDialog: false,
  typeForm: {
    extended_properties: [],
    actions: [],
    interface: [],
  },
  // 属性列表
  propList: [],
  // 动作列表
  actionList: [],
  // 界面列表
  interfaceList: [],
  typeList: [],
  typeMap: {},
}

const actions = {
  async reverseShowTypeStatus({ commit }, status) {
    commit('REVERSE_SHOW_TYPE_STATUS', status)
  },
  async setTypeInfo({ commit }, typeInfo) {
    // state.typeForm
    typeInfo = typeInfo ?? {};
    commit('SET_TYPE_FORM', typeInfo);
    commit('SET_PROP_LIST', typeInfo.extended_properties ?? []);
    commit('SET_ACTION_LIST', typeInfo.actions ?? []);
    commit('SET_INTERFACE_LIST', typeInfo.interface ?? []);
  },
  async setEmptyTypeInfo({ commit }) {
    commit('SET_TYPE_FORM', {
      extended_properties: [],
      actions: [],
      interface: [],
    })
  },
  async saveTypeInfo({ commit, state, dispatch }, {  editorId, courseId }) {
    let form = Object.assign({}, state.typeForm);

    form.sceneId = editorId;

    form.extended_properties = state.propList ?? [];
    form.actions = state.actionList ?? [];
    form.interface = state.interfaceList ?? [];
    form.type = 'editor';

    const result = await saveDiviceType(form);
    if (result.code == 200) {
      const data = result.data._id ? result.data : form;
      commit('SET_TYPE_MAP_ITEM', data);
      dispatch('reverseShowTypeStatus', 'close');
      dispatch('loadData', courseId)
      this.dispatch('editorDefinition/setTypeId', data._id);

      this.dispatch('global/showSuccessMsg', '操作成功');
    }
  },
  async setExtendedProperties({ commit, state }, extFormData) {
    let form = Object.assign({}, extFormData);
    const propList = state.propList;
    if (form.id) {
      const index = propList.findIndex(item => item.id === extFormData.id);
      propList[index] = form;
    } else {
      form.id = `ext_${new Date().getTime()}`;
      propList.push(form)
    }
    commit('SET_PROP_LIST', propList)
  },
  async removeProp({ commit, state }, index) {
    const list = state.propList;
    if (index > -1) {
      list.splice(index, 1);
      commit('SET_PROP_LIST', list);
    }
  },
  async setAction({ commit, state }, actionFormData) {
    let form = Object.assign({}, actionFormData);
    const actionList = state.actionList;
    if (form.id) {
      const actIndex = actionList.findIndex(
        (item) => item.id === form.id
      );
      actionList[actIndex] = form;
    } else {
      form.id = `device_act_${new Date().getTime()}`;
      actionList.push(form);
    }
    commit('SET_ACTION_LIST', actionList)
  },
  async removeAction({ commit, state }, index) {
    const list = state.actionList;
    if (index > -1) {
      list.splice(index, 1);
      commit('SET_ACTION_LIST', list);
    }
  },
  async setInterface({ commit, state }, interfaceFormData) {
    let form = Object.assign({}, interfaceFormData);
    const interfaceList = state.interfaceList;
    if (form.id) {
      const intIndex = interfaceList.findIndex(
        (item) => item.id === form.id
      );
      interfaceList[intIndex] = form;
    } else {
      form.id = `ui_page_int_${new Date().getTime()}`;
      interfaceList.push(form);
    }
    commit('SET_INTERFACE_LIST', interfaceList)
  },
  async removeInterface({ commit, state }, index) {
    const list = state.interfaceList;
    if (index > -1) {
      list.splice(index, 1);
      commit('SET_INTERFACE_LIST', list);
    }
  },
  async loadData({ commit }, courseId) {
    const res = await findEditorTypeList({ courseId })
    if (res.code == 200) {
      const typeMap = res.data.reduce((pre, next) => {
        pre[next._id] = next;
        return pre
      }, {});

      commit('SET_TYPE_LIST', res.data);
      commit('SET_TYPE_MAP', typeMap);
    }
  },
  async reverseShowExtDialog({ commit }, status) {
    commit('REVERSE_SHOW_EXT_DIALOG_STATUS', status)
  },
  async removeType({ commit, state }, id) {
    const res = await removeType(id);
    if (res.code == 200) {
      const index = state.typeList.findIndex(item => item._id === id);
      commit('REMOVE_TYPE', index)
    }
  }
}

const mutations = {
  REVERSE_SHOW_TYPE_STATUS(state, status) {
    state.showType = status;
  },
  REVERSE_SHOW_EXT_DIALOG_STATUS(state, status) {
    state.showType = status;
  },
  SET_TYPE_LIST(state, data) {
    state.typeList = data;
  },
  SET_PROP_LIST(state, data) {
    state.propList = [].concat(data);
  },
  SET_ACTION_LIST(state, data) {
    state.actionList = [].concat(data);
  },
  SET_INTERFACE_LIST(state, data) {
    state.interfaceList = [].concat(data);
  },
  SET_TYPE_MAP(state, map) {
    state.typeMap = map;
  },
  SET_TYPE_MAP_ITEM(state, typeInfo) {
    state.typeMap[typeInfo._id] =  Object.assign({}, typeInfo);
  },
  SET_TYPE_FORM(state, typeInfo) {
    state.typeForm = Object.assign({}, typeInfo);
  },
  INIT_TYPE_FORM(state) {
    state.typeForm = {
      extended_properties: [],
      actions: [],
      interface: [],
    }
  },
  REMOVE_TYPE(state, index) {
    state.typeList.splice(index, 1);
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
